import { defineStore } from 'pinia';
import { ref } from 'vue';
import { GetRouteAccess } from '../services/Users/GetRouteAccess';
import { RouteAccessDataInterface } from '../types/getRouteAccessInterface';

export const useRouteAccessStore = defineStore('routeAccess', () => {
  const routeAccess = ref<RouteAccessDataInterface>({
    isAuthenticated: false,
    isAllowedToAccess: false,
    redirectUrl: '',
    accessLevelStatus: '',
  });

  const getClient = async () => {
    try {
      const response: RouteAccessDataInterface = await GetRouteAccess();
      routeAccess.value = {
        isAuthenticated: response.isAuthenticated,
        isAllowedToAccess: response.isAllowedToAccess,
        redirectUrl: response.redirectUrl,
        accessLevelStatus: response.accessLevelStatus,
      };
    } catch (error) {
      console.error(error);
    }
  };

  return {
    routeAccess,
    getClient,
  };
});
